import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=b8640a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8640a48"]])

export default __exports__